module.exports = require('./head');



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash/first.js
// module id = 2152
// module chunks = 25